module.exports = __webpack_public_path__ + "img/needle_app.0caa4b22.png";